
// Topic progression metadata for smart skill navigation
export const topicProgression = {
  "summerPrep": ["multiplication", "functions", "exponents", "quadratics", "unitCircle"],
  "limits": ["evaluatingLimitsFromRepresentations", "continuityAndLimitTheorems", "evaluatingLimitsAlgebraicManipulation", "limitsAtInfinity", "choosingALimitProcedure"],
  "derivatives": ["derivativeConcepts", "powerRule", "productRule", "trigonometricDerivatives", "naturalDerivatives", "curveSketching"],
  "integrals": ["singleTermIntegration", "polynomialIntegration", "trigonometricIntegration", "naturalIntegration", "definiteIntegrals", "functionsDefinedAsIntegrals", "propertiesOfDefiniteIntegrals", "differentialEquations"],
  "review": ["derivativesReview", "reviewCards"]
};

export const unitProgression = ["summerPrep", "limits", "derivatives", "integrals", "review"];

const topicsPathwayArray = [
	{
		skillId: 10,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "multiplication",
		topicDisplayName: "Multiplication",
		skill: "multiplicationTable",
		skillDisplayName: "Multiplication Table",
		description: "Memorize multiplication facts up to 12x12.",
		expectedTime: 120,
		baseTickets: 20,
		level: 10,
		isLive: true,
		path: "/cubesAndSquares/multiplication?skillId=10",
	},
	{
		skillId: 20,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "multiplication",
		topicDisplayName: "Multiplication",
		skill: "multiplicationMix",
		skillDisplayName: "Multiplication Tables Mixed",
		description: "30 randomized multiplication facts up to 12x12.",
		expectedTime: 120,
		baseTickets: 20,
		level: 20,
		isLive: true,
		path: "/cubesAndSquares/multiplicationMix?skillId=20",
	},
	{
		skillId: 25,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "multiplication",
		topicDisplayName: "Multiplication",
		skill: "multiplicationFactsChallenge",
		skillDisplayName: "Multiplication Facts Challenge",
		description: "Complete30 randomized multiplication facts up to 12x12 in under 2 minutes.",
		expectedTime: 120,
		baseTickets: 20,
		level: 20,
		isLive: true,
		path: "/cubesAndSquares/multiplicationFactsChallenge?skillId=25",
	},	
	{
		skillId: 30,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "multiplication",
		topicDisplayName: "Multiplication",
		skill: "squaringNumbers",
		skillDisplayName: "Squaring Numbers",
		description: "Square numbers up to 12 squared.",
		expectedTime: 60,
		baseTickets: 20,
		level: 30,
		isLive: true,
		path: "/cubesAndSquares/squares?skillId=30",
	},
	
	{
		skillId: 40,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "multiplication",
		topicDisplayName: "Multiplication",
		skill: "cubingNumbers",
		skillDisplayName: "Cubing Numbers",
		description: "Cube numbers up to 7 cubed.",
		expectedTime: 75,
		baseTickets: 20,
		level: 40,
		isLive: true,
		path: "/cubesAndSquares/cubes?skillId=40",
	},
	// {
	// 	skillId: 50,
	// 	course: "AP Calculus AB",
	// 	section: "calculusSkills",
	// 	unit: "summerPrep",
	// 	unitDisplayName: "Summer Prep",
	// 	topic: "multiplication",
	// 	topicDisplayName: "Multiplication",
	// 	skill: "multiplyingFractions",
	// 	skillDisplayName: "Multiplying Fractions",
	// 	description: "Multiply fractions and mixed numbers.",
	// 	expectedTime: 120,
	// 	baseTickets: 20,
	// 	level: 50,
	// 	isLive: false,
	// },
	// {
	// 	skillId: 60,
	// 	course: "AP Calculus AB",
	// 	section: "calculusSkills",
	// 	unit: "summerPrep",
	// 	unitDisplayName: "Summer Prep",
	// 	topic: "multiplication",
	// 	topicDisplayName: "Multiplication",
	// 	skill: "orderOfOperations",
	// 	skillDisplayName: "Order of Operations",
	// 	description: "Apply the order of operations in multi-step problems.",
	// 	expectedTime: 120,
	// 	baseTickets: 20,
	// 	level: 60,
	// 	isLive: false,
	// },
	{
		skillId: 100,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "functions",
		topicDisplayName: "Functions",
		skill: "functionNotation",
		skillDisplayName: "Function Notation",
		description: "Evaluate functions.",
		expectedTime: 200,
		baseTickets: 25,
		level: 100,
		isLive: true,
		path: "/functionNotation?skillId=100",
	},
	{
		skillId: 110,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "functions",
		topicDisplayName: "Functions",
		skill: "plottingPointsPolynomials",
		skillDisplayName: "Polynomial Functions",
		description: "Plot and analyze polynomial functions.",
		expectedTime: 137,
		baseTickets: 30,
		level: 110,
		isLive: true,
		path: "/plottingPointsPolynomials?skillId=110",
	},
	{
		skillId: 120,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "functions",
		topicDisplayName: "Functions",
		skill: "plottingPointsSine",
		skillDisplayName: "Sine Function",
		description: "Plot points and understand sine function behavior.",
		expectedTime: 236,
		baseTickets: 30,
		level: 120,
		isLive: true,
		path: "/plottingPoints?skillId=120",
	},
	{
		skillId: 130,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "functions",
		topicDisplayName: "Functions",
		skill: "plottingPointsCosine",
		skillDisplayName: "Cosine Function",
		description: "Plot points and understand cosine function behavior.",
		expectedTime: 216,
		baseTickets: 30,
		level: 130,
		isLive: true,
		path: "/plottingPoints?skillId=130",
	},
	{
		skillId: 140,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "functions",
		topicDisplayName: "Functions",
		skill: "identifyingFunctions",
		skillDisplayName: "Identifying Functions",
		description: "Identify and classify different types of functions.",
		expectedTime: 60,
		baseTickets: 20,
		level: 140,
		isLive: true,
		path: "/identifyingFunctions?skillId=140",
	},
	{
		skillId: 150,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "functions",
		topicDisplayName: "Functions",
		skill: "equationsOfLines",
		skillDisplayName: "Equations of Lines",
		description: "Find and work with linear equations and their properties.",
		expectedTime: 250,
		baseTickets: 20,
		level: 150,
		isLive: true,
		path: "/equationsOfLines?skillId=150",
	},
	{
		skillId: 200,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "exponents",
		topicDisplayName: "Exponents",
		skill: "positive",
		skillDisplayName: "Simple Exponents",
		description: "Work with positive integer exponents and basic exponential rules.",
		expectedTime: 99,
		baseTickets: 20,
		level: 200,
		isLive: true,
		path: "/exponentsVariety?skillId=200",
	},
	{
		skillId: 210,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "exponents",
		topicDisplayName: "Exponents",
		skill: "negative",
		skillDisplayName: "Negative Exponents",
		description: "Understand and apply negative exponent rules.",
		expectedTime: 135,
		baseTickets: 25,
		level: 210,
		isLive: true,
		path: "/exponentsVariety?skillId=210",
	},
	{
		skillId: 220,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "exponents",
		topicDisplayName: "Exponents",
		skill: "fractional",
		skillDisplayName: "Fractional Exponents",
		description: "Work with fractional exponents and radical expressions.",
		expectedTime: 120,
		baseTickets: 25,
		level: 220,
		isLive: true,
		path: "/exponentsVariety?skillId=220",
	},
	{
		skillId: 230,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "exponents",
		topicDisplayName: "Exponents",
		skill: "negativeFractional",
		skillDisplayName: "Negative Fractional Exponents",
		description: "Apply rules for negative fractional exponents.",
		expectedTime: 120,
		baseTickets: 30,
		level: 230,
		isLive: true,
		path: "/exponentsVariety?skillId=230",
	},
	{
		skillId: 240,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "exponents",
		topicDisplayName: "Exponents",
		skill: "mixed",
		skillDisplayName: "Mix of All Types",
		description: "Practice all types of exponent rules in mixed problems.",
		expectedTime: 120,
		baseTickets: 30,
		level: 240,
		isLive: true,
		path: "/exponentsVariety?skillId=240",
	},
	{
		skillId: 300,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "quadratics",
		topicDisplayName: "Quadratics",
		skill: "differenceOfSquares",
		skillDisplayName: "Difference of Squares",
		description: "Factor expressions using the difference of squares formula.",
		expectedTime: 60,
		baseTickets: 20,
		level: 300,
		isLive: true,
		path: "/factoringQuadratics/differenceOfSquares?skillId=300",
	},
	{
		skillId: 310,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "quadratics",
		topicDisplayName: "Quadratics",
		skill: "factoringQuadratics",
		skillDisplayName: "Factoring Quadratics",
		description: "Factor quadratic expressions and solve quadratic equations.",
		expectedTime: 140,
		baseTickets: 30,
		level: 310,
		isLive: true,
		path: "/factoringQuadratics/factoringQuadratics?skillId=310",
	},
	{
		skillId: 401,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "unitCircle",
		topicDisplayName: "Unit Circle",
		skill: "unitCircleWarmUpFirstQuadrant",
		skillDisplayName: "Warm Up: First Quadrant",
		description: "Warm up exercises for unit circle coordinates in the first quadrant.",
		expectedTime: 180,
		baseTickets: 20,
		level: 401,
		isLive: true,
		path: "/unitCircle?skillId=401",
	},
	{
		skillId: 402,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "unitCircle",
		topicDisplayName: "Unit Circle",
		skill: "unitCircleWarmUpSecondQuadrant",
		skillDisplayName: "Warm Up: Second Quadrant",
		description: "Warm up exercises for unit circle coordinates in the second quadrant.",
		expectedTime: 274,
		baseTickets: 20,
		level: 402,
		isLive: true,
		path: "/unitCircle?skillId=402",
	},
	{
		skillId: 403,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "unitCircle",
		topicDisplayName: "Unit Circle",
		skill: "unitCircleWarmUpThirdQuadrant",
		skillDisplayName: "Warm Up: Third Quadrant",
		description: "Warm up exercises for unit circle coordinates in the third quadrant.",
		expectedTime: 266,
		baseTickets: 20,
		level: 403,
		isLive: true,
		path: "/unitCircle?skillId=403",
	},
	{
		skillId: 404,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "unitCircle",
		topicDisplayName: "Unit Circle",
		skill: "unitCircleWarmUpFourthQuadrant",
		skillDisplayName: "Warm Up: Fourth Quadrant",
		description: "Warm up exercises for unit circle coordinates in the fourth quadrant.",
		expectedTime: 146,
		baseTickets: 20,
		level: 404,
		isLive: true,
		path: "/unitCircle?skillId=404",
	},
	{
		skillId: 431,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "unitCircle",
		topicDisplayName: "Unit Circle",
		skill: "unitCircleSineFirstQuadrant",
		skillDisplayName: "Practice: Sine - First Quadrant",
		description: "Practice sine values on the unit circle in the first quadrant.",
		expectedTime: 56,
		baseTickets: 20,
		level: 431,
		isLive: true,
		path: "/unitCircle?skillId=431",
	},
	{
		skillId: 432,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "unitCircle",
		topicDisplayName: "Unit Circle",
		skill: "unitCircleSineFirstHalf",
		skillDisplayName: "Practice: Sine - First Half",
		description: "Practice sine values on the unit circle in the first half.",
		expectedTime: 73,
		baseTickets: 20,
		level: 432,
		isLive: true,
		path: "/unitCircle?skillId=432",
	},
	{
		skillId: 433,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "unitCircle",
		topicDisplayName: "Unit Circle",
		skill: "unitCircleSineFullCircle",
		skillDisplayName: "Practice: Sine - Full Circle",
		description: "Practice sine values on the unit circle for the full circle.",
		expectedTime: 118,
		baseTickets: 20,
		level: 433,
		isLive: true,
		path: "/unitCircle?skillId=433",
	},
	{
		skillId: 434,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "unitCircle",
		topicDisplayName: "Unit Circle",
		skill: "unitCircleCosineFirstQuadrant",
		skillDisplayName: "Practice: Cosine - First Quadrant",
		description: "Practice cosine values on the unit circle in the first quadrant.",
		expectedTime: 23,
		baseTickets: 20,
		level: 434,
		isLive: true,
		path: "/unitCircle?skillId=434",
	},
	{
		skillId: 435,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "unitCircle",
		topicDisplayName: "Unit Circle",
		skill: "unitCircleCosineFirstHalf",
		skillDisplayName: "Practice: Cosine - First Half",
		description: "Practice cosine values on the unit circle in the first half.",
		expectedTime: 41,
		baseTickets: 20,
		level: 435,
		isLive: true,
		path: "/unitCircle?skillId=435",
	},
	{
		skillId: 436,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "unitCircle",
		topicDisplayName: "Unit Circle",
		skill: "unitCircleCosineFullCircle",
		skillDisplayName: "Practice: Cosine - Full Circle",
		description: "Practice cosine values on the unit circle for the full circle.",
		expectedTime: 86,
		baseTickets: 20,
		level: 436,
		isLive: true,
		path: "/unitCircle?skillId=436",
	},
	{
		skillId: 437,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "unitCircle",
		topicDisplayName: "Unit Circle",
		skill: "unitCircleTangentFirstQuadrant",
		skillDisplayName: "Practice: Tangent - First Quadrant",
		description: "Practice tangent values on the unit circle in the first quadrant.",
		expectedTime: 58,
		baseTickets: 20,
		level: 437,
		isLive: true,
		path: "/unitCircle?skillId=437",
	},
	{
		skillId: 438,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "unitCircle",
		topicDisplayName: "Unit Circle",
		skill: "unitCircleTangentFirstHalf",
		skillDisplayName: "Practice: Tangent - First Half",
		description: "Practice tangent values on the unit circle in the first half.",
		expectedTime: 63,
		baseTickets: 20,
		level: 438,
		isLive: true,
		path: "/unitCircle?skillId=438",
	},
	{
		skillId: 439,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "unitCircle",
		topicDisplayName: "Unit Circle",
		skill: "unitCircleTangentFullCircle",
		skillDisplayName: "Practice: Tangent - Full Circle",
		description: "Practice tangent values on the unit circle for the full circle.",
		expectedTime: 136,
		baseTickets: 20,
		level: 439,
		isLive: true,
		path: "/unitCircle?skillId=439",
	},
	{
		skillId: 471,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "unitCircle",
		topicDisplayName: "Unit Circle",
		skill: "unitCircleFirstQuadrant",
		skillDisplayName: "Test: First Quadrant",
		description: "Test your knowledge of unit circle values in the first quadrant.",
		expectedTime: 72,
		baseTickets: 20,
		level: 471,
		isLive: true,
		path: "/unitCircle?skillId=471",
	},
	{
		skillId: 472,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "unitCircle",
		topicDisplayName: "Unit Circle",
		skill: "unitCircleFirstHalf",
		skillDisplayName: "Test: First Half",
		description: "Test your knowledge of unit circle values in the first half.",
		expectedTime: 106,
		baseTickets: 20,
		level: 472,
		isLive: true,
		path: "/unitCircle?skillId=472",
	},
	{
		skillId: 473,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "unitCircle",
		topicDisplayName: "Unit Circle",
		skill: "unitCircleFullCircle",
		skillDisplayName: "Test: Full Circle",
		description: "Test your knowledge of unit circle values for the full circle.",
		expectedTime: 120,
		baseTickets: 40,
		level: 473,
		isLive: true,
		path: "/unitCircle?skillId=473",
	},
	{
		skillId: 490,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "summerPrep",
		unitDisplayName: "Summer Prep",
		topic: "unitCircle",
		topicDisplayName: "Unit Circle",
		skill: "essentialUnitCircle",
		skillDisplayName: "The Absolute Essentials",
		description: "Master the absolute essential unit circle values and concepts.",
		expectedTime: 120,
		baseTickets: 40,
		level: 490,
		isLive: true,
		path: "/unitCircle?skillId=490",
	},
	{
		skillId: 1110,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "evaluatingLimitsFromRepresentations",
		topicDisplayName: "Evaluating Limits From Representations",
		skill: "limitsLanguage",
		skillDisplayName: "The Language of Limits",
		description: "Practice reading limit notation and using the language of limits.",
		expectedTime: 120,
		baseTickets: 30,
		level: 1110,
		isLive: true,
		path: "/limitsLanguage?skillId=1110",
	},
	{
		skillId: 1120,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "evaluatingLimitsFromRepresentations",
		topicDisplayName: "Evaluating Limits From Representations",
		skill: "tableLimits",
		skillDisplayName: "Evaluating Limits From Tables",
		description: "Practice evaluating one-sided and two-sided limits using tables of values.",
		expectedTime: 120,
		baseTickets: 30,
		level: 1120,
		isLive: true,
		path: "/limitsTables?skillId=1120",
	},
	{
		skillId: 1130,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "evaluatingLimitsFromRepresentations",
		topicDisplayName: "Evaluating Limits From Representations",
		skill: "graphicalLimits",
		subSkill: "basic",
		skillDisplayName: "Evaluating Limits From Graphs",
		description: "Practice evaluating limits using graphs of functions.",
		expectedTime: 120,
		baseTickets: 30,
		level: 1130,
		isLive: true,
		isStandard: true,
		path: "/limitsGraphs?skillId=1130",
	},
	{
		skillId: 1140,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "evaluatingLimitsFromRepresentations",
		topicDisplayName: "Evaluating Limits From Representations",
		skill: "graphicalLimits",
		subSkill: "oneSided",
		skillDisplayName: "One-Sided Limits From Graphs",
		description: "Practice evaluating one-sided limits using graphs of functions.",
		expectedTime: 120,
		baseTickets: 30,
		level: 1140,
		isLive: true,
		isStandard: false,
		path: "/limitsGraphs?skillId=1140",
	},
	{
		skillId: 1150,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "evaluatingLimitsFromRepresentations",
		topicDisplayName: "Evaluating Limits From Representations",
		skill: "graphicalLimits",
		subSkill: "complex",
		skillDisplayName: "Complex Graphs",
		description: "Practice evaluating one-sided and two-sided limits using complex graphs of functions.",
		expectedTime: 120,
		baseTickets: 30,
		level: 1150,
		isLive: true,
		isStandard: false,
		path: "/limitsGraphs?skillId=1150",
	},
	{
		skillId: 1160,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "evaluatingLimitsFromRepresentations",
		topicDisplayName: "Evaluating Limits From Representations",
		skill: "evaluatingLimitsFromFunctionExpressions",
		skillDisplayName: "Evaluating Limits From Function Expressions",
		description: "Practice evaluating one-sided and two-sided limits using function expressions.",
		expectedTime: 120,
		baseTickets: 30,
		level: 1160,
		isLive: true,
		path: "/limitsExpressions?skillId=1160",
	},
	{
		skillId: 1170,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "evaluatingLimitsFromRepresentations",
		topicDisplayName: "Evaluating Limits From Representations",
		skill: "evaluatingBasicLimitsMix",
		skillDisplayName: "Evaluating Limits — Mixed Representations",
		description: "Practice evaluating limits from tables, graphs, and function expressions.",
		expectedTime: 120,
		baseTickets: 30,
		level: 1170,
		isLive: true,
		path: "/limitsMix?skillId=1170",
	},
	{
		skillId: 1180,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "evaluatingLimitsFromRepresentations",
		topicDisplayName: "Evaluating Limits From Representations",
		skill: "squeezeTheorem",
		skillDisplayName: "Applying the Squeeze Theorem",
		description: "Apply the Squeeze Theorem to evaluate limits, including classic trigonometric cases.",
		expectedTime: 120,
		baseTickets: 30,
		level: 1180,
		isLive: true,
		path: "/limitsSqueeze?skillId=1180",
	},
	{
		skillId: 1210,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "continuityAndLimitTheorems",
		topicDisplayName: "Continuity and Limit Theorems",
		skill: "limitProperties",
		skillDisplayName: "Applying Limit Properties",
		description: "Apply sum, product, quotient, constant-multiple, and composition limit properties.",
		expectedTime: 120,
		baseTickets: 30,
		level: 1210,
		isLive: true,
		path: "/limitsProperties?skillId=1210",
	},
	{
		skillId: 1220,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "continuityAndLimitTheorems",
		topicDisplayName: "Continuity and Limit Theorems",
		skill: "checkingContinuityAtAPoint",
		skillDisplayName: "Checking Continuity at a Point",
		description: "Practice the three-part check for continuity at a point using graphs and function expressions.",
		expectedTime: 120,
		baseTickets: 30,
		level: 1220,
		isLive: true,
		path: "/limitsContinuity?skillId=1220",
	},
	{
		skillId: 1230,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "continuityAndLimitTheorems",
		topicDisplayName: "Continuity and Limit Theorems",
		skill: "removingADiscontinuity",
		skillDisplayName: "Removing a Discontinuity",
		description: "Find the value that removes a removable discontinuity and restores continuity at a point.",
		expectedTime: 120,
		baseTickets: 30,
		level: 1230,
		isLive: true,
		path: "/limitsRemovable?skillId=1230",
	},
	{
		skillId: 1240,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "continuityAndLimitTheorems",
		topicDisplayName: "Continuity and Limit Theorems",
		skill: "continuityOnAnInterval",
		skillDisplayName: "Continuity on an Interval",
		description: "Decide whether a function is continuous on a closed interval, including endpoints.",
		expectedTime: 120,
		baseTickets: 30,
		level: 1240,
		isLive: true,
		path: "/limitsIntervalContinuity?skillId=1240",
	},
	{
		skillId: 1250,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "continuityAndLimitTheorems",
		topicDisplayName: "Continuity and Limit Theorems",
		skill: "intermediateValueTheorem",
		skillDisplayName: "Applying the Intermediate Value Theorem",
		description: "Practice using the Intermediate Value Theorem to decide whether a value is guaranteed on an interval.",
		expectedTime: 120,
		baseTickets: 30,
		level: 1250,
		isLive: true,
		path: "/limitsIVT?skillId=1250",
	},
	{
		skillId: 1310,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "evaluatingLimitsAlgebraicManipulation",
		topicDisplayName: "Evaluating Limits With Algebraic Manipulation",
		skill: "limitsFactoring",
		skillDisplayName: "Evaluating Limits by Factoring",
		description: "Practice evaluating limits using factoring techniques.",
		expectedTime: 240,
		baseTickets: 40,
		level: 1310,
		isLive: true,
		path: "/limitsDividingOut?skillId=1310",
	},
	{
		skillId: 1320,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "evaluatingLimitsAlgebraicManipulation",
		topicDisplayName: "Evaluating Limits With Algebraic Manipulation",
		skill: "limitsRationalizing",
		skillDisplayName: "Evaluating Limits Using Rationalization",
		description: "Practice evaluating limits using rationalization techniques.",
		expectedTime: 240,
		baseTickets: 40,
		level: 1320,
		isLive: true,
		path: "/limitsDividingOut?skillId=1320",
	},
	{
		skillId: 1330,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "evaluatingLimitsAlgebraicManipulation",
		topicDisplayName: "Evaluating Limits With Algebraic Manipulation",
		skill: "verticalAsymptotes",
		skillDisplayName: "Vertical Asymptotes and Holes",
		description: "Practice finding vertical asymptotes of rational functions.",
		expectedTime: 240,
		baseTickets: 40,
		level: 1330,
		isLive: true,
		path: "/limitsDividingOut?skillId=1330",
	},
	{
		skillId: 1410,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "limitsAtInfinity",
		topicDisplayName: "Limits at Infinity and End Behavior",
		skill: "limitsAtInfinity",
		skillDisplayName: "Limits at Infinity and Horizontal Asymptotes",
		description: "Practice evaluating limits at infinity.",
		expectedTime: 120,
		baseTickets: 30,
		level: 1410,
		isLive: true,
		path: "/limitsDividingOut?skillId=1410",
	},
	{
		skillId: 1420,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "limitsAtInfinity",
		topicDisplayName: "Limits at Infinity and End Behavior",
		skill: "limitsAtInfinityWithManipulation",
		skillDisplayName: "Evaluating Limits At Infinity With Manipulation",
		description: "Practice manipulating function to evaluate limits at infinity.",
		expectedTime: 120,
		baseTickets: 30,
		level: 1420,
		isLive: true,
		path: "/limitsDividingOut?skillId=1420",
	},
	{
		skillId: 1510,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "limits",
		unitDisplayName: "Limits",
		topic: "choosingALimitProcedure",
		topicDisplayName: "Choosing a Limit Procedure",
		skill: "limitsProcedureMix",
		skillDisplayName: "Choosing a Limit Procedure",
		description: "Choose a technique and evaluate mixed limit problems.",
		expectedTime: 180,
		baseTickets: 30,
		level: 1510,
		isLive: true,
		path: "/limitsProcedureMix?skillId=1510",
	},
	// Integer Exponents Sub-Skills
	{
		skillId: 2000,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "derivativeConcepts",
		topicDisplayName: "Derivative Concepts",
		skill: "rateOfChange",
		skillDisplayName: "Rate of Change",
		description: "Identify what average rate of change and the derivative mean.",
		expectedTime: 80,
		baseTickets: 30,
		level: 2000,
		isLive: true,
		isStandard: false,
		path: "/averageRateOfChange?skillId=2000",
	},
	{
		skillId: 2002,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "derivativeConcepts",
		topicDisplayName: "Derivative Concepts",
		skill: "averageRateOfChange",
		skillDisplayName: "Average Rate of Change - From a Table",
		description: "Calculate the average rate of change of a function over an interval from a table.",
		expectedTime: 80,
		baseTickets: 30,
		level: 2002,
		isLive: true,
		isStandard: false,
		path: "/averageRateOfChange?skillId=2002",
	},
	{
		skillId: 2004,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "derivativeConcepts",
		topicDisplayName: "Derivative Concepts",
		skill: "averageRateOfChangeFromAGraph",
		skillDisplayName: "Average Rate of Change - From a Graph",
		description: "Calculate the average rate of change of a function over an interval from a graph.",
		expectedTime: 80,
		baseTickets: 30,
		level: 2004,
		isLive: true,
		isStandard: false,
		path: "/averageRateOfChange?skillId=2004",
	},
	{
		skillId: 2006,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "derivativeConcepts",
		topicDisplayName: "Derivative Concepts",
		skill: "averageRateOfChangeFromAFunctionExpression",
		skillDisplayName: "Average Rate of Change - From a Function Expression",
		description: "Calculate the average rate of change of a function over an interval from a function expression.",
		expectedTime: 80,
		baseTickets: 30,
		level: 2006,
		isLive: true,
		isStandard: false,
		path: "/averageRateOfChange?skillId=2006",
	},
	{
		skillId: 2010,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "derivativeConcepts",
		topicDisplayName: "Derivative Concepts",
		skill: "averageRateOfChangeMix",
		skillDisplayName: "Average Rate of Change - Mix",
		description: "Calculate the average rate of change of a function over an interval from a table, graph, or function expression.",
		expectedTime: 80,
		baseTickets: 30,
		level: 2010,
		isLive: true,
		isStandard: false,
		path: "/averageRateOfChange?skillId=2010",
	},
	{
		skillId: 2011,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "powerRule",
		topicDisplayName: "Power Rule",
		skill: "integerExponents",
		subSkill: "noCoefficient",
		skillDisplayName: "Integer Exponents - No Coefficient",
		description: "Apply the power rule to functions with integer exponents and no coefficients.",
		expectedTime: 80,
		baseTickets: 30,
		level: 2011,
		isLive: true,
		isStandard: false,
		path: "/derivatives?skillId=2011",
	},
	{
		skillId: 2012,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "powerRule",
		topicDisplayName: "Power Rule",
		skill: "integerExponents",
		subSkill: "integerCoefficient",
		skillDisplayName: "Integer Exponents - Integer Coefficient",
		description: "Apply the power rule to functions with integer exponents and integer coefficients.",
		expectedTime: 90,
		baseTickets: 30,
		level: 2012,
		isLive: true,
		isStandard: false,
		path: "/derivatives?skillId=2012",
	},
	{
		skillId: 2013,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "powerRule",
		topicDisplayName: "Power Rule",
		skill: "integerExponents",
		subSkill: "fractionalCoefficient",
		skillDisplayName: "Integer Exponents - Fractional Coefficient",
		description: "Apply the power rule to functions with integer exponents and fractional coefficients.",
		expectedTime: 100,
		baseTickets: 30,
		level: 2013,
		isLive: true,
		isStandard: false,
		path: "/derivatives?skillId=2013",
	},
	{
		skillId: 2014,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "powerRule",
		topicDisplayName: "Power Rule",
		skill: "integerExponents",
		subSkill: "mixedCoefficient",
		skillDisplayName: "Integer Exponents - Mixed Coefficient",
		description: "Apply the power rule to functions with integer exponents and mixed coefficient types.",
		expectedTime: 120,
		baseTickets: 40,
		level: 2014,
		isLive: true,
		isStandard: true,
		path: "/derivatives?skillId=2014",
	},
	// Negative Exponents Sub-Skills
	{
		skillId: 2021,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "powerRule",
		topicDisplayName: "Power Rule",
		skill: "negativeExponents",
		subSkill: "noCoefficient",
		skillDisplayName: "Negative Exponents - No Coefficient",
		description: "Apply the power rule to functions with negative exponents and no coefficients.",
		expectedTime: 120,
		baseTickets: 30,
		level: 2021,
		isLive: true,
		isStandard: false,
		path: "/derivatives?skillId=2021",
	},
	{
		skillId: 2022,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "powerRule",
		topicDisplayName: "Power Rule",
		skill: "negativeExponents",
		subSkill: "integerCoefficient",
		skillDisplayName: "Negative Exponents - Integer Coefficient",
		description: "Apply the power rule to functions with negative exponents and integer coefficients.",
		expectedTime: 180,
		baseTickets: 30,
		level: 2022,
		isLive: true,
		isStandard: false,
		path: "/derivatives?skillId=2022",
	},
	{
		skillId: 2023,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "powerRule",
		topicDisplayName: "Power Rule",
		skill: "negativeExponents",
		subSkill: "fractionalCoefficient",
		skillDisplayName: "Negative Exponents - Fractional Coefficient",
		description: "Apply the power rule to functions with negative exponents and fractional coefficients.",
		expectedTime: 180,
		baseTickets: 30,
		level: 2023,
		isLive: true,
		isStandard: false,
		path: "/derivatives?skillId=2023",
	},
	{
		skillId: 2024,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "powerRule",
		topicDisplayName: "Power Rule",
		skill: "negativeExponents",
		subSkill: "mixedCoefficient",
		skillDisplayName: "Negative Exponents - Mixed Coefficient",
		description: "Apply the power rule to functions with negative exponents and mixed coefficient types.",
		expectedTime: 180,
		baseTickets: 40,
		level: 2024,
		isLive: true,
		isStandard: true,
		path: "/derivatives?skillId=2024",
	},
	// Fractional Exponents Sub-Skills
	{
		skillId: 2031,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "powerRule",
		topicDisplayName: "Power Rule",
		skill: "fractionalExponents",
		subSkill: "noCoefficient",
		skillDisplayName: "Fractional Exponents - No Coefficient",
		description: "Apply the power rule to functions with fractional exponents and no coefficients.",
		expectedTime: 140,
		baseTickets: 30,
		level: 2031,
		isLive: true,
		isStandard: false,
		path: "/derivatives?skillId=2031",
	},
	{
		skillId: 2032,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "powerRule",
		topicDisplayName: "Power Rule",
		skill: "fractionalExponents",
		subSkill: "integerCoefficient",
		skillDisplayName: "Fractional Exponents - Integer Coefficient",
		description: "Apply the power rule to functions with fractional exponents and integer coefficients.",
		expectedTime: 180,
		baseTickets: 30,
		level: 2032,
		isLive: true,
		isStandard: false,
		path: "/derivatives?skillId=2032",
	},
	{
		skillId: 2033,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "powerRule",
		topicDisplayName: "Power Rule",
		skill: "fractionalExponents",
		subSkill: "fractionalCoefficient",
		skillDisplayName: "Fractional Exponents - Fractional Coefficient",
		description: "Apply the power rule to functions with fractional exponents and fractional coefficients.",
		expectedTime: 180,
		baseTickets: 30,
		level: 2033,
		isLive: true,
		isStandard: false,
		path: "/derivatives?skillId=2033",
	},
	{
		skillId: 2034,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "powerRule",
		topicDisplayName: "Power Rule",
		skill: "fractionalExponents",
		subSkill: "mixedCoefficient",
		skillDisplayName: "Fractional Exponents - Mixed Coefficient",
		description: "Apply the power rule to functions with fractional exponents and mixed coefficient types.",
		expectedTime: 240,
		baseTickets: 40,
		level: 2034,
		isLive: true,
		isStandard: true,
		path: "/derivatives?skillId=2034",
	},
	// Negative Fractional Exponents Sub-Skills
	{
		skillId: 2041,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "powerRule",
		topicDisplayName: "Power Rule",
		skill: "negativeFractionalExponents",
		subSkill: "noCoefficient",
		skillDisplayName: "Negative Fractional Exponents - No Coefficient",
		description: "Apply the power rule to functions with negative fractional exponents and no coefficients.",
		expectedTime: 120,
		baseTickets: 30,
		level: 2041,
		isLive: true,
		isStandard: false,
		path: "/derivatives?skillId=2041",
	},
	{
		skillId: 2042,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "powerRule",
		topicDisplayName: "Power Rule",
		skill: "negativeFractionalExponents",
		subSkill: "integerCoefficient",
		skillDisplayName: "Negative Fractional Exponents - Integer Coefficient",
		description: "Apply the power rule to functions with negative fractional exponents and integer coefficients.",
		expectedTime: 120,
		baseTickets: 30,
		level: 2042,
		isLive: true,
		isStandard: false,
		path: "/derivatives?skillId=2042",
	},
	{
		skillId: 2043,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "powerRule",
		topicDisplayName: "Power Rule",
		skill: "negativeFractionalExponents",
		subSkill: "fractionalCoefficient",
		skillDisplayName: "Negative Fractional Exponents - Fractional Coefficient",
		description: "Apply the power rule to functions with negative fractional exponents and fractional coefficients.",
		expectedTime: 140,
		baseTickets: 30,
		level: 2043,
		isLive: true,
		isStandard: false,
		path: "/derivatives?skillId=2043",
	},
	{
		skillId: 2044,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "powerRule",
		topicDisplayName: "Power Rule",
		skill: "negativeFractionalExponents",
		subSkill: "mixedCoefficient",
		skillDisplayName: "Negative Fractional Exponents - Mixed Coefficient",
		description: "Apply the power rule to functions with negative fractional exponents and mixed coefficient types.",
		expectedTime: 240,
		baseTickets: 40,
		level: 2044,
		isLive: true,
		isStandard: true,
		path: "/derivatives?skillId=2044",
	},
	{
		skillId: 2050,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "powerRule",
		topicDisplayName: "Power Rule",
		skill: "powerRuleMix",
		skillDisplayName: "Power Rule Mix",
		description: "Practice the power rule with mixed types of exponents.",
		expectedTime: 180,
		baseTickets: 40,
		level: 2050,
		isLive: true,
		path: "/derivatives?skillId=2050",
	},
	{
		skillId: 2080,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "productRule",
		topicDisplayName: "Product Rule",
		skill: "productRule",
		skillDisplayName: "Product Rule - Intro",
		description: "Apply the Product Rule to find the derivative of the product of two functions.",
		expectedTime: 360,
		baseTickets: 40,
		level: 2080,
		isLive: true,
		path: "/productQuotientRule?skillId=2080",
	},
	// {
	// 	skillId: 2090,
	// 	course: "AP Calculus AB",
	// 	section: "calculusSkills",
	// 	unit: "derivatives",
	// 	unitDisplayName: "Derivatives",
	// 	topic: "quotientRule",
	// 	topicDisplayName: "Quotient Rule",
	// 	skill: "quotientRule",
	// 	skillDisplayName: "Quotient Rule - Intro",
	// 	description: "Apply the Quotient Rule to find the derivative of the quotient of two functions.",
	// 	expectedTime: 120,
	// 	baseTickets: 40,
	// 	level: 2090,
	// 	isLive: true,
	// 	path: "/productQuotientRule?skillId=2090",
	// },	
	{
		skillId: 2110,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "trigonometricDerivatives",
		topicDisplayName: "Trigonometric Derivatives",
		skill: "simpleTrigonometric",
		skillDisplayName: "Trig Derivatives",
		description: "Learn to differentiate basic trigonometric functions.",
		expectedTime: 120,
		baseTickets: 30,
		level: 2110,
		isLive: true,
		path: "/derivatives?skillId=2110",
	},
	{
		skillId: 2120,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "trigonometricDerivatives",
		topicDisplayName: "Trigonometric Derivatives",
		skill: "simpleChainRuleTrigonometric",
		skillDisplayName: "Chain Rule Trig Derivatives",
		description: "Apply the chain rule to differentiate composite trigonometric functions.",
		expectedTime: 240,
		baseTickets: 30,
		level: 2120,
		isLive: true,
		path: "/derivatives?skillId=2120",
	},
	{
		skillId: 2210,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "naturalDerivatives",
		topicDisplayName: "Natural Log/Exponential Derivatives",
		skill: "naturalExponential",
		skillDisplayName: "Natural Exponential",
		description: "Learn to differentiate natural exponential functions.",
		expectedTime: 90,
		baseTickets: 30,
		level: 2210,
		isLive: true,
		path: "/derivatives?skillId=2210",
	},
	{
		skillId: 2220,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "naturalDerivatives",
		topicDisplayName: "Natural Log/Exponential Derivatives",
		skill: "complexNaturalExponential",
		skillDisplayName: "Complex Natural Exponential",
		description: "Learn to differentiate complex natural exponential functions.",
		expectedTime: 160,
		baseTickets: 40,
		level: 2220,
		isLive: true,
		path: "/derivatives?skillId=2220",
	},
	{
		skillId: 2230,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "naturalDerivatives",
		topicDisplayName: "Natural Log/Exponential Derivatives",
		skill: "simpleNaturalLog",
		skillDisplayName: "Natural Log",
		description: "Learn to differentiate natural logarithmic functions.",
		expectedTime: 180,
		baseTickets: 30,
		level: 2230,
		isLive: true,
		path: "/derivatives?skillId=2230",
	},
	{
		skillId: 2240,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "naturalDerivatives",
		topicDisplayName: "Natural Log/Exponential Derivatives",
		skill: "complexNaturalLog",
		skillDisplayName: "Complex Natural Log",
		description: "Learn to differentiate complex natural logarithmic functions.",
		expectedTime: 240,
		baseTickets: 40,
		level: 2240,
		isLive: true,
		path: "/derivatives?skillId=2240",
	},
		{
		skillId: 2250,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "naturalDerivatives",
		topicDisplayName: "Natural Log/Exponential Derivatives",
		skill: "mixNaturalExponentialAndLog",
		skillDisplayName: "Mixed Natural Log and Natural Exponential",
		description: "Learn to differentiate mixed natural exponential and logarithmic functions.",
		expectedTime: 180,
		baseTickets: 40,
		level: 2250,
		isLive: true,
		path: "/derivatives?skillId=2250",
	},
	{
		skillId: 2300,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "naturalDerivatives",
		topicDisplayName: "Natural Log/Exponential Derivatives",
		skill: "exponentialFunctionsBaseA",
		skillDisplayName: "General Exponential Functions",
		description: "Learn to differentiate general exponential functions with arbitrary bases.",
		expectedTime: 240,
		baseTickets: 40,
		level: 2300,
		isLive: false,
		path: "/derivatives?skillId=2300",
	},
	{
		skillId: 2350,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "naturalDerivatives",
		topicDisplayName: "Natural Log/ExponentialDerivatives",
		skill: "logFunctionsBaseA",
		skillDisplayName: "General Log Functions",
		description: "Learn to differentiate general logarithmic functions with arbitrary bases.",
		expectedTime: 240,
		baseTickets: 40,
		level: 2350,
		isLive: false,
		path: "/derivatives?skillId=2350",
	},
	{
		skillId: 2410,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "review",
		unitDisplayName: "Review",
		topic: "derivativesReview",
		topicDisplayName: "Derivatives Review",
		skill: "derivativesOfEverythingNoChainRule",
		skillDisplayName: "Derivatives of Everything - No Chain Rule",
		description: "Practice with the full variety of derivatives with no chain rule problems.",
		expectedTime: 240,
		baseTickets: 50,
		level: 2410,
		isLive: true,
		path: "/productQuotientRule?skillId=2410",
	},
	{
		skillId: 2420,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "review",
		unitDisplayName: "Review",
		topic: "derivativesReview",
		topicDisplayName: "Derivatives Review",
		skill: "allDerivativesChainRule",
		skillDisplayName: "Derivatives - Chain Rule",
		description: "Practice with the full variety of functions that require the chain rule to find the derivative.",
		expectedTime: 360,
		baseTickets: 50,
		level: 2420,
		isLive: true,
		path: "/productQuotientRule?skillId=2420",
	},			
	// {
	// 	skillId: 3011,
	// 	course: "AP Calculus AB",
	// 	section: "calculusSkills",
	// 	unit: "derivatives",
	// 	unitDisplayName: "Derivatives",
	// 	topic: "naturalDerivatives",
	// 	topicDisplayName: "Natural Log/Exponential Derivatives",
	// 	skill: "naturalExponential",
	// 	skillDisplayName: "Natural Exponential",
	// 	description: "Learn to differentiate natural exponential functions.",
	// 	expectedTime: 108,
	// 	baseTickets: 40,
	// 	level: 3011,
	// 	isLive: true,
	// 	path: "/naturalDerivatives?skillId=3011",
	// },
	// {
	// 	skillId: 3012,
	// 	course: "AP Calculus AB",
	// 	section: "calculusSkills",
	// 	unit: "derivatives",
	// 	unitDisplayName: "Derivatives",
	// 	topic: "naturalDerivatives",
	// 	topicDisplayName: "Natural Log/Exponential Derivatives",
	// 	skill: "complexNaturalExponential",
	// 	skillDisplayName: "Complex Natural Exponential",
	// 	description: "Learn to differentiate complex natural exponential functions.",
	// 	expectedTime: 120,
	// 	baseTickets: 40,
	// 	level: 3012,
	// 	isLive: true,
	// 	path: "/naturalDerivatives?skillId=3012",
	// },
	// {
	// 	skillId: 3013,
	// 	course: "AP Calculus AB",
	// 	section: "calculusSkills",
	// 	unit: "derivatives",
	// 	unitDisplayName: "Derivatives",
	// 	topic: "naturalDerivatives",
	// 	topicDisplayName: "Natural Log/Exponential Derivatives",
	// 	skill: "simpleNaturalLog",
	// 	skillDisplayName: "Simple Natural Log",
	// 	description: "Learn to differentiate simple natural logarithmic functions.",
	// 	expectedTime: 1230,
	// 	baseTickets: 40,
	// 	level: 3013,
	// 	isLive: true,
	// 	path: "/naturalDerivatives?skillId=3013",
	// },
	// {
	// 	skillId: 3014,
	// 	course: "AP Calculus AB",
	// 	section: "calculusSkills",
	// 	unit: "derivatives",
	// 	unitDisplayName: "Derivatives",
	// 	topic: "naturalDerivatives",
	// 	topicDisplayName: "Natural Log/Exponential Derivatives",
	// 	skill: "complexNaturalLog",
	// 	skillDisplayName: "Complex Natural Log",
	// 	description: "Learn to differentiate complex natural logarithmic functions.",
	// 	expectedTime: 120,
	// 	baseTickets: 40,
	// 	level: 3014,
	// 	isLive: true,
	// 	path: "/naturalDerivatives?skillId=3014",
	// },
	// {
	// 	skillId: 3015,
	// 	course: "AP Calculus AB",
	// 	section: "calculusSkills",
	// 	unit: "derivatives",
	// 	unitDisplayName: "Derivatives",
	// 	topic: "naturalDerivatives",
	// 	topicDisplayName: "Natural Log/Exponential Derivatives",
	// 	skill: "mixNaturalExponentialAndLog",
	// 	skillDisplayName: "Mixed Natural Functions",
	// 	description: "Learn to differentiate mixed natural exponential and logarithmic functions.",
	// 	expectedTime: 120,
	// 	baseTickets: 40,
	// 	level: 3015,
	// 	isLive: true,
	// 	path: "/naturalDerivatives?skillId=3015",
	// },
	// {
	// 	skillId: 3016,
	// 	course: "AP Calculus AB",
	// 	section: "calculusSkills",
	// 	unit: "derivatives",
	// 	unitDisplayName: "Derivatives",
	// 	topic: "naturalDerivatives",
	// 	topicDisplayName: "Natural Log/Exponential Derivatives",
	// 	skill: "exponentialFunctionsBaseA",
	// 	skillDisplayName: "General Exponential Functions",
	// 	description: "Learn to differentiate general exponential functions with arbitrary bases.",
	// 	expectedTime: 120,
	// 	baseTickets: 40,
	// 	level: 3016,
	// 	isLive: true,
	// 	path: "/naturalDerivatives?skillId=3016",
	// },
	// {
	// 	skillId: 3017,
	// 	course: "AP Calculus AB",
	// 	section: "calculusSkills",
	// 	unit: "derivatives",
	// 	unitDisplayName: "Derivatives",
	// 	topic: "naturalDerivatives",
	// 	topicDisplayName: "Natural Log/Exponential Derivatives",
	// 	skill: "logFunctionsBaseA",
	// 	skillDisplayName: "General Log Functions",
	// 	description: "Learn to differentiate general logarithmic functions with arbitrary bases.",
	// 	expectedTime: 120,
	// 	baseTickets: 40,
	// 	level: 3017,
	// 	isLive: true,
	// 	path: "/naturalDerivatives?skillId=3017",
	// },
		{
		skillId: 2700,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "curveSketching",
		topicDisplayName: "Curve Sketching",
		skill: "curveSketchingIntroTutorial",
		skillDisplayName: "Tutorial: Introduction to Curve Sketching",
		description: "Use the first and second derivative to describe a function.",
		expectedTime: 360,
		baseTickets: 40,
		level: 2700,
		isLive: true,
		path: "/curveSketchingIntroTutorial?skillId=2700",
	},
	{
		skillId: 2710,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "curveSketching",
		topicDisplayName: "Curve Sketching",
		skill: "curveSketchingFirstDerivative",
		skillDisplayName: "Curve Sketching - First Derivative",
		description: "Use the first derivative to describe a function.",
		expectedTime: 240,
		baseTickets: 40,
		level: 2710,
		isLive: true,
		path: "/curveSketchingIntroTutorial?skillId=2710",
	},	
	{
		skillId: 2790,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "derivatives",
		unitDisplayName: "Derivatives",
		topic: "curveSketching",
		topicDisplayName: "Curve Sketching",
		skill: "curveSketchingIntro",
		skillDisplayName: "Skill: Curve Sketching",
		description: "Use the first and second derivative to describe a function.",
		expectedTime: 150,
		baseTickets: 40,
		level: 2790,
		isLive: true,
		path: "/curveSketchingIntroTutorial?skillId=2790",
	},	
	{
		skillId: 3110,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "singleTermIntegration",
		topicDisplayName: "Single Term Integration",
		skill: "indefiniteIntegralsSingleTerm",
		skillDisplayName: "Single Term Integration",
		description: "Learn to integrate single term functions using basic integration rules.",
		expectedTime: 180,
		baseTickets: 40,
		level: 3110,
		isLive: true,
		path: "/integration?skillId=3110",
	},
	{
		skillId: 3111,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "singleTermIntegration",
		topicDisplayName: "Single Term Integration",
		skill: "indefiniteIntegralsSingleTermCoefficients",
		skillDisplayName: "Single Term Integration With Coefficients",
		description: "Learn to integrate single term functions with coefficients using basic integration rules.",
		expectedTime: 300,
		baseTickets: 40,
		level: 3111,
		isLive: true,
		path: "/integration?skillId=3111",
	},
	{
		skillId: 3112,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "singleTermIntegration",
		topicDisplayName: "Single Term Integration",
		skill: "indefiniteIntegralsSingleTermNegativeExponents",
		skillDisplayName: "Single Term Integration With Negative Exponents",
		description: "Learn to integrate single term functions with negative exponents using basic integration rules.",
		expectedTime: 360,
		baseTickets: 40,
		level: 3112,
		isLive: true,
		path: "/integration?skillId=3112",
	},
	{
		skillId: 3113,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "singleTermIntegration",
		topicDisplayName: "Single Term Integration",
		skill: "indefiniteIntegralsSingleTermFractionalExponents",
		skillDisplayName: "Single Term Integration With Fractional Exponents",
		description: "Learn to integrate single term functions with fractional exponents using basic integration rules.",
		expectedTime: 480,
		baseTickets: 40,
		level: 3113,
		isLive: true,
		path: "/integration?skillId=3113",
	},
	{
		skillId: 3114,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "singleTermIntegration",
		topicDisplayName: "Single Term Integration",
		skill: "indefiniteIntegralsSingleTermNegativeFractionalExponents",
		skillDisplayName: "Single Term Integration With Negative Fractional Exponents",
		description: "Learn to integrate single term functions with negative fractional exponents using basic integration rules.",
		expectedTime: 360,
		baseTickets: 40,
		level: 3114,
		isLive: true,
		path: "/integration?skillId=3114",
	},
	{
		skillId: 3115,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "singleTermIntegration",
		topicDisplayName: "Single Term Integration",
		skill: "indefiniteIntegralsSingleTermMix",
		skillDisplayName: "Single Term Integration Mix",
		description: "Learn to integrate single term functions with negative fractional exponents using basic integration rules.",
		expectedTime: 300,
		baseTickets: 50,
		level: 3115,
		isLive: true,
		path: "/integration?skillId=3115",
	},					
	{
		skillId: 3120,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "polynomialIntegration",
		topicDisplayName: "Polynomial Integration",
		skill: "indefiniteIntegralsBinomial",
		skillDisplayName: "Binomial Integration",
		description: "Learn to integrate binomial expressions using integration techniques.",
		expectedTime: 300,
		baseTickets: 40,
		level: 3120,
		isLive: true,
		path: "/integration?skillId=3120",
	},
	{
		skillId: 3130,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "polynomialIntegration",
		topicDisplayName: "Polynomial Integration",
		skill: "indefiniteIntegralsPolynomial",
		skillDisplayName: "Polynomial Integration",
		description: "Learn to integrate polynomial functions using power rule for integration.",
		expectedTime: 300,
		baseTickets: 40,
		level: 3130,
		isLive: true,
		path: "/integration?skillId=3130",
	},
	{
		skillId: 3150,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "polynomialIntegration",
		topicDisplayName: "Polynomial Integration",
		skill: "indefiniteIntegralsChainRule",
		skillDisplayName: "Integration of Binomials and Trinomials Raised to a Power",
		description: "Learn to integrate functions the require u-substitution.",
		expectedTime: 600,
		baseTickets: 50,
		level: 3150,
		isLive: true,
		path: "/integration?skillId=3150",
	},	
	{
		skillId: 3210,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "trigonometricIntegration",
		topicDisplayName: "Trigonometric Integration",
		skill: "indefiniteIntegralsTrigonometric",
		skillDisplayName: "Trigonometric Integration",
		description: "Learn to integrate trigonometric functions using trigonometric integration rules.",
		expectedTime: 180,
		baseTickets: 40,
		level: 3210,
		isLive: true,
		path: "/integration?skillId=3210",
	},
	{
		skillId: 3220,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "trigonometricIntegration",
		topicDisplayName: "Trigonometric Integration",
		skill: "indefiniteIntegralsTrigonometricChainRule",
		skillDisplayName: "Trigonometric Integration Chain Rule",
		description: "Learn to integrate trigonometric functions where the derivative required the chain rule.",
		expectedTime: 300,
		baseTickets: 50,
		level: 3220,
		isLive: true,
		path: "/integration?skillId=3220",
	},
	{
		skillId: 3230,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "trigonometricIntegration",
		topicDisplayName: "Trigonometric Integration",
		skill: "indefiniteIntegralsTrigonometricChainRuleExponents",
		skillDisplayName: "Trigonometric Integration Chain Rule Exponents",
		description: "Learn to integrate trigonometric functions where the derivative required the chain rule.",
		expectedTime: 480,
		baseTickets: 50,
		level: 3230,
		isLive: true,
		path: "/integration?skillId=3230",
	},		
	{
		skillId: 3310,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "naturalIntegration",
		topicDisplayName: "Natural Log/Exponential Integration",
		skill: "indefiniteIntegralsNaturalExponential",
		skillDisplayName: "Natural Exponential Integration",
		description: "Learn to integrate natural exponential functions using exponential integration rules.",
		expectedTime: 180,
		baseTickets: 40,
		level: 3310,
		isLive: true,
		path: "/integration?skillId=3310",
	},
	{
		skillId: 3320,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "naturalIntegration",
		topicDisplayName: "Natural Log/Exponential Integration",
		skill: "indefiniteIntegralsNaturalLog",
		skillDisplayName: "Natural Log Integration",
		description: "Learn to integrate natural logarithmic functions using integration by parts.",
		expectedTime: 180,
		baseTickets: 40,
		level: 3320,
		isLive: true,
		path: "/integration?skillId=3320",
	},
	{
		skillId: 3330,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "naturalIntegration",
		topicDisplayName: "Natural Log/Exponential Integration",
		skill: "indefiniteIntegralsNaturalLogBinomial",
		skillDisplayName: "Binomial Natural Log Integration",
		description: "Learn to integrate binomial natural logarithmic functions using integration by parts.",
		expectedTime: 240,
		baseTickets: 40,
		level: 3330,
		isLive: true,
		path: "/integration?skillId=3330",
	},
	{
		skillId: 3410,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "definiteIntegrals",
		topicDisplayName: "Definite Integrals",
		skill: "definiteIntegralSingleTerm",
		skillDisplayName: "Basic Definite Integrals",
		description: "Calculate definite integrals.",
		expectedTime: 360,
		baseTickets: 40,
		level: 3410,
		isLive: true,
		path: "/integration?skillId=3410",
	},
	{
		skillId: 3450,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "definiteIntegrals",
		topicDisplayName: "Definite Integrals",
		skill: "definiteIntegralSimpleTrig",
		skillDisplayName: "Definite Integrals Using Simple Trigonometric Functions",
		description: "Calculate definite integrals involving the sine and cosine.",
		expectedTime: 360,
		baseTickets: 50,
		level: 3450,
		isLive: true,
		path: "/integration?skillId=3450",
	},
	{
		skillId: 3451,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "definiteIntegrals",
		topicDisplayName: "Definite Integrals",
		skill: "definiteIntegralSimpleTrigAllAngles",
		skillDisplayName: "Definite Integrals Using Simple Trigonometric Functions (all angles in Quadarant 1)",
		description: "Calculate definite integrals involving the sine and cosine for all angles in Quadrant 1",
		expectedTime: 420,
		baseTickets: 50,
		level: 3451,
		isLive: true,
		path: "/integration?skillId=3451",
	},
	{
		skillId: 3510,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "functionsDefinedAsIntegrals",
		topicDisplayName: "Functions Defined as Integrals",
		skill: "functionsDefinedAsIntegralsAccumulation",
		skillDisplayName: "Accumulation Functions",
		description: "calculate the total accumulation of a function defined as an integral",
		expectedTime: 240,
		baseTickets: 50,
		level: 3510,
		isLive: true,
		path: "/integrationAccumulation?skillId=3510",
	},
	{
		skillId: 3610,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "propertiesOfDefiniteIntegrals",
		topicDisplayName: "Properties of Definite Integrals",
		skill: "propertiesOfDefiniteIntegrals",
		skillDisplayName: "Properties of Definite Integrals",
		description: "calculate the value of definite integrals from functions and graphs",
		expectedTime: 240,
		baseTickets: 50,
		level: 3510,
		isLive: true,
		path: "/integrationAccumulation?skillId=3610",
	},
	{
		skillId: 4210,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "integrals",
		unitDisplayName: "Integrals",
		topic: "differentialEquations",
		topicDisplayName: "Differential Equations",
		skill: "separationOfVariables",
		skillDisplayName: "Separation of Variables",
		description: "Solve differential equations using the method of separation of variables.",
		expectedTime: 1080,
		baseTickets: 60,
		level: 4210,
		isLive: true,
		path: "/separationOfVariables?skillId=4210",
	},
	{
		skillId: 9000,
		course: "AP Calculus AB",
		section: "calculusSkills",
		unit: "review",
		unitDisplayName: "Review",
		topic: "reviewCards",
		topicDisplayName: "Review Cards",
		skill: "reviewCards",
		skillDisplayName: "Review Cards",
		description: "Review all previously learned skills.",
		expectedTime: 120,
		baseTickets: 40,
		level: 9000,
		isLive: true,
		path: "/reviewCards/sessions?skillId=9000",
	},					
];

export default topicsPathwayArray;
